import React, { useState } from "react";
import { Link } from "gatsby";
import NewletterModal from "../common/NewletterModal";

const EventContent = ({ data }) => {
  const [openModal, setOpenModal] = useState(false);

  function getDate(updatedAt) {
    const date = new Date(updatedAt);
    const formattedDate = date.toLocaleString("en-US", {
      weekday: "short",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });

    return formattedDate; // Output: "Fri, Mar 2012"
  }

  function isArray(data) {
    return Array.isArray(data);
  }

  return (
    <div className="blogContent">
      <h1>{data.title}</h1>
      {!!data.images?.length &&
        data.images?.map((image) => (
          <>
            <img
              src={image}
              alt={data.title}
              loading="eager"
              className="thumbnail__image"
            />
            <img
              src={image}
              alt={data.title}
              loading="eager"
              className="thumbnail__image__mobile"
            />
          </>
        ))}

      <div className="content">
        <div
          dangerouslySetInnerHTML={{
            __html: data.body,
          }}
        />
        <div>
          {data.event_type && (
            <h6>
              Event Type: <span>{data.event_type}</span>
            </h6>
          )}
        </div>
        <div className="conferences">
          <h6 className="font-bold">Event Dates:</h6>
          <ul className="pl-0">
            {isArray(data.event_dates)
              ? data.event_dates?.map(
                  (event, index) =>
                    event?.starts_at &&
                    event?.ends_at && (
                      <li key={index}>
                        <span>{getDate(event?.starts_at)}</span> -{" "}
                        <span>{getDate(event?.ends_at)}</span>
                      </li>
                    )
                )
              : data?.starts_at &&
                data?.ends_at && (
                  <li>
                    <span>{getDate(data.starts_at)}</span> -{" "}
                    <span>{getDate(data.ends_at)}</span>
                  </li>
                )}
          </ul>
        </div>
      </div>

      <div className="my-10">
        <button
          className="border-btn-rounded-white d-none d-lg-inline-flex no-underline"
          onClick={() => setOpenModal(true)}
        >
          Subscribe
        </button>
      </div>

      {!!data?.tags?.length && (
        <div className="tag__container">
          <h6>
            Tags:
            <div className="space-x-1 ml-2 pl-0 inline-block">
              {data?.tags?.map((tag, index) => (
                <Link key={index} to={`/${tag.slug}`}>
                  <span>{tag.name}</span> {data.tags?.length > index + 1 && ","}
                </Link>
              ))}
            </div>
          </h6>
        </div>
      )}

      {openModal && <NewletterModal closeModal={() => setOpenModal(false)} />}
    </div>
  );
};

export default EventContent;
